export default __webpack_public_path__ + "static/media/royalbank.5220a74c.webp";